let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5meAl")).then(() => parcelRequire('2Z7LQ'));